import React, { useState, useEffect, useRef } from 'react';
import queryString from 'query-string';
import { Form, Progress, Alert } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { useLocalization } from '../../containers/I18nProvider';
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: '',
  });
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    changeDefaultLocale('es');
    setShowForm(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true);
    setError({
      open: false,
      message: '',
    });

    api.userPassLogin(
      {
        username,
        password,
        cp_convert: parameters.cp_convert,
      },
      parameters,
    )
      .then((response) => {
        setOnLogin(false);
        window.location = `${parameters.redirect_uri}?${queryString.stringify(response)}`;
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate('RequestLoginErrorMessage');
        if (_translate) message = _translate;
        else if (error.details) message = error.details;
        setOnLogin(false);
        setError({ open: true, message });
      });
  };

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="nubenetar-wrapper" ref={nodeRef}>
        <div className="nubenetar-card">
          <div className="nubenetar-card-header">
            <h1>{translate('ClientAuthentication')}</h1>
            <p>{translate('WelcomeMessage')}</p>
          </div>

          <Form onSubmit={onSubmit}>
            <div className="nubenetar-field">
              <label htmlFor="nubenetar-username">{translate('LabelUserName')}</label>
              <input
                id="nubenetar-username"
                type="text"
                required
                disabled={onLogin}
                autoCorrect="off"
                autoCapitalize="none"
                autoComplete="username"
                placeholder={translate('PlaceholderUserName')}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="nubenetar-field">
              <label htmlFor="nubenetar-password">{translate('LabelPassword')}</label>
              <input
                id="nubenetar-password"
                type="password"
                required
                disabled={onLogin}
                autoComplete="current-password"
                placeholder={translate('PlaceholderPassword')}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="nubenetar-captcha">
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
            </div>

            <div className="nubenetar-submit-wrap">
              {!onLogin ? (
                <button
                  type="submit"
                  className="nubenetar-submit"
                  disabled={!props.turnstileSuccess}
                >
                  {translate('ButtonEnter')}
                </button>
              ) : (
                <Progress animated color="primary" value={100} />
              )}
            </div>

            <Alert
              color="danger"
              isOpen={error.open}
              toggle={() => setError({ open: false })}
              className="nubenetar-error"
            >
              {error.message}
            </Alert>
          </Form>

          <div className="nubenetar-forgot">
            <a href="https://idp.nubenet.com.ar/password/reset/request" target="_blank" rel="noopener noreferrer">
              {translate('ForgotPassword')}
            </a>
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};

export default WithCaptcha(LoginForm, { useInsideForm: true });
